import React from "react";
import AppLayout from "../components/AppLayout";
import NotificationCTA from "../components/NotificationCTA";

const NotificationsPage = () => (
    <AppLayout pageTitle="Notifiche" showBack backTo="/">
        <NotificationCTA />
    </AppLayout>
);

export default NotificationsPage;
